import { Chip, Slider, Stack, Text } from '@/design';

interface PointCloudSliceToolProps {
  offset: number;
  onChange(offset: number): void;
}

export function PointCloudSliceTool({ offset, onChange }: PointCloudSliceToolProps) {
  return (
    <Stack direction="column" gap={1}>
      <Text variant="caption" as="span">
        Slice tool (S)
      </Text>
      <Slider
        min={-100}
        max={100}
        step={1}
        value={Math.round(offset * 100)}
        aria-label="Point cloud slice offset"
        onChange={(next) => onChange(next / 100)}
      />
      <Chip icon="splitscreen" label={`Offset ${Math.round(offset * 100)}%`} variant="neutral" />
    </Stack>
  );
}
